import { Switch } from 'react-router-dom';
import { useModuleFeatureFlag } from '@/providers/FeatureFlag.provider';
import TransactionsHistory from '../Transaction/TransactionsHistory/TransactionsHistory';
import TransactionsHistoryDetails from '../Transaction/TransactionsHistory/TransactionDetails';
import TransactionConfirmationPage from '../Transaction/TransactionConfirmationPage';
import Reconciliation from '../Transaction/Reconciliation/ReconciliationContainer';
import ReconciliationDetails from '../Transaction/Reconciliation/Details/ReconciliationTransactionDetails';
import BankVerifyHistory from './BankVerifyHistory/BankVerifyHistory';
import BankVerifyHistoryDetails from './BankVerifyHistory/Details/BankVerifyDetailsContainer';

import { usePermissions } from '../../providers/Permissions.provider';
import ProtectedRoute from '../../utils/ProtectedRoute';

import ReportsPage from './Reports/ReportsPage';
import ReportsDetailsPage from './Reports/Details/ReportDetailsPage';
import MyAccountConfirmationPage from '../Accounts/MyAccountConfirmation/MyAccountConfirmationPage';
import { JSX } from 'react';
import { useClientData } from '@/providers/ClientData.provider';

const Routes = (): JSX.Element => {
  const { permissions } = usePermissions();
  const featureFlags = useModuleFeatureFlag('statements');
  const {
    response: { AccountType },
  } = useClientData();

  return (
    <Switch>
      <ProtectedRoute
        isAllowed={featureFlags.isEnabled && AccountType === 'Technology'}
        showPermission
        exact
        path="/reconciliation"
        component={Reconciliation}
      />
      <ProtectedRoute
        isAllowed={featureFlags.isEnabled && AccountType === 'Technology'}
        showPermission
        exact
        path="/reconciliation/details/:BatchID"
        component={ReconciliationDetails}
      />
      <ProtectedRoute
        isAllowed={featureFlags.isEnabled && featureFlags.ViewBankVerify}
        showPermission
        exact
        path="/bank-verify-history"
        component={BankVerifyHistory}
      />
      <ProtectedRoute
        isAllowed={featureFlags.isEnabled && featureFlags.ViewBankVerify}
        showPermission
        exact
        path="/bank-verify-history/details/:VerificationRequestID"
        component={BankVerifyHistoryDetails}
      />
      <ProtectedRoute
        isAllowed={featureFlags.isEnabled && featureFlags.ViewTransactionReport}
        showPermission
        exact
        path="/reports"
        component={ReportsPage}
      />
      <ProtectedRoute
        isAllowed={featureFlags.isEnabled && featureFlags.ViewTransactionReport}
        showPermission
        exact
        path="/reports/:ReportID"
        component={ReportsDetailsPage}
      />
      <ProtectedRoute
        isAllowed={!!permissions.ViewTransactionHistory && featureFlags.isEnabled}
        showPermission
        exact
        path="/transactions-history"
        component={TransactionsHistory}
      />
      <ProtectedRoute
        isAllowed={!!permissions.ViewTransactionHistory && featureFlags.isEnabled}
        showPermission
        exact
        path="/transaction-confirmation/:type/:mode/:transactionType/:transactionId/:currency"
        component={TransactionConfirmationPage}
      />
      <ProtectedRoute
        isAllowed={!!permissions.ViewTransactionHistory && featureFlags.isEnabled}
        showPermission
        exact
        path="/transactions-history/details/:TransactionType/:TransactionID/:Currency"
        component={TransactionsHistoryDetails}
      />
      <ProtectedRoute
        isAllowed={
          (!!permissions.CreateFundMyAccountTransactions || !!permissions.CreateWithdrawMyAccountTransactions) &&
          featureFlags.isEnabled
        }
        showPermission
        exact
        path="/my-account-confirmation/:transactionId/:currency/:flow/:category"
        component={MyAccountConfirmationPage}
      />
    </Switch>
  );
};

export default Routes;
